module.exports = __webpack_public_path__ + "img/pt.b4b8fd77.png";